import React from "react";

const words = ["Games", "Apps", "iOS", "Android", "Web", "Design", "Launch", "Grow"];

const Marquee = () => (
  <div className="marquee" aria-hidden="true">
    <div className="marquee-track">
      {[...words, ...words, ...words, ...words].map((w, i) => (
        <span key={i}>
          {w}
          <i>✦</i>
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
